import 'css-chunksrc/client/pages/workloadPage/table/projectsDetail/projectRow/cell/numberInput/styles.scss';export default {
  "numberInput": "_numberInput_gxk8n_1",
  "main": "_main_gxk8n_9",
  "arrows": "_arrows_gxk8n_17",
  "input": "_input_gxk8n_21",
  "icon": "_icon_gxk8n_50",
  "iconBox": "_iconBox_gxk8n_54",
  "disabled": "_disabled_gxk8n_75"
};